export const Settings = {
  centerOfMap: {
    lat: 35.685314,
    lon: 139.7528424,
  },
};
